import React, { useContext, useEffect, useState } from 'react'
import ModalMain from '../../../../components/Modal/ModalMain'
import ModalHeader from '../../../../components/Modal/ModalHeader';
import { Dropdown } from '@fluentui/react';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { t } from 'i18next';
import { extendStudyExpiration } from '../../../../service/StudyViewerService';
import studyviewerContext from '../../../../context/studyviewer/StudyviewerContext';
import { eventBus } from '../../../Annotations/helper/initialData';
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import ViewportContext from '../../../../context/studyviewer/ViewportContext';
import themeContext from '../../../../context/theme/ThemeContext';
import { getEnv } from '../../../../helpers/EnvHelper';

const StudyExpirationPopup = (props) => {
    const { studyParentId, setShowStudyExpirationPopup, showStudyAlreadyExpiredPopup, setShowStudyAlreadyExpiredPopup, checkStudyExpired, setCheckStudyExpired, setReportMenu } =
    useContext(studyviewerContext);

    const { releaseStudy, editorRef } = useContext(studyReportContext);
    const { viewportDoubleClickIndex } = useContext(ViewportContext);
    const { getThemeColor, themeName, getScrollBarStyleForTheme } = useContext(themeContext);

    let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;

    // useEffect(() => {
    //   if(document.fullscreenElement) {
    //     document.exitFullscreen().catch((err) => {
    //       console.error('Failed to exit fullscreen:', err);
    //     });
    //   }
    // }, []);

    useEffect(() => {
      eventBus.on("configureStudyExpirationModal", (evtData) => {
        setShowStudyAlreadyExpiredPopup(evtData.show);
      });
    }, []);

    useEffect(() => {
      eventBus.on("toggleFullscreen", (evtData) => {
        console.log("Event toggleFullscreen is listening...........");
        const editor = editorRef?.current?.editor;
        if (editor && editor.fullscreen.isActive()) {
          console.log("Exiting fullscreen mode due to study expiration.");
          editor.fullscreen.toggle();
        }

        if(document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {
            console.error('Failed to exit fullscreen:', err);
          });
        }
      });
    }, []);

    let PrimaryButtonList = showStudyAlreadyExpiredPopup ? [
        {
          title: t("button.ok"),
          onclick: () => {
            const params = new URLSearchParams(window.location.search);
            const blitzSession = params.get("blitzSession");
            if (blitzSession) {
              console.log("Blitz session active ");
              window.parent.goToNextStudy(false);
            }else{
              window.close();
            }
          },
        },
      ] : [
        {
          title: t("study-expiration.button.extend"),
          onclick: () => {
            console.log("extend clicked")
            handleStudyExpirationExtent();
          },
        },
        isBvpPlatform ? {
            title: t("study-expiration.button.release"),
            onclick: () => {
              console.log("return clicked")
              handleStudyRelease();
            },
          } : {
            title: t("study-expiration.button.return"),
            onclick: () => {
              console.log("return clicked")
              handleStudyReturn();
            },
          },
      ];

    const modalDetails = {
        header: (
          <ModalHeader
              heading={t("study-expiration.title")}
              hideCancelIcon={true}
              updatedModal={true}
            />
        ),
        body: <div className="return-study-container" data-theme={themeName}>
            <div className="return-study-content">
            <div className="ReturnStudyContentContainer">
                {!showStudyAlreadyExpiredPopup && (
                  <div className="expiration-timer-container">
                    <span
                      className="expiration-timer-text"
                      id="timerDisplayOnPopup"
                    ></span>
                  </div>
                )}

                {showStudyAlreadyExpiredPopup && (
                  <div>
                    <p>Study is expired. You can no longer save or submit.</p>
                  </div>
                )}
            </div>
            </div>
        </div>,
        footer: (
          <ModalFooter
             PrimaryButtonList={PrimaryButtonList}
          />
        ),
        width: "400px", 
      };

  const handleStudyExpirationExtent = async () => {
    const response = await extendStudyExpiration(studyParentId);
    console.log(response)
    if (response.status == 200 && response.data.data == true) {
      setShowStudyExpirationPopup(false);
      setCheckStudyExpired(!checkStudyExpired);
  
      if (viewportDoubleClickIndex != null && viewportDoubleClickIndex !== -1 && setReportMenu) {
        setReportMenu(false);
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 200);
    }
  }

  const handleStudyReturn = () => {
    props.setShowReturnStudyModal(true);
  }

  const handleStudyRelease = () => {
    releaseStudy(studyParentId);
    setShowStudyExpirationPopup(false);
  }

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  )
}

export default StudyExpirationPopup
